import { FooterContainer } from './Footer.container';

export const Footer = () => {
	return <FooterContainer />;
};
